import { Feature } from '@/services/mapbox';
import * as pym from 'pym.js';
import * as React from 'react';

export interface MainContextType {
  addressFeature: Feature | null;
  setAddressFeature: (f: Feature | null) => void;
  votingFeatures: Feature[] | null;
  setVotingFeatures: (f: Feature[] | null) => void;
  resetAllFeatures: () => void;
}

const INITIAL_STATE = {
  addressFeature: null,
  setAddressFeature: () => {},
  votingFeatures: null,
  setVotingFeatures: () => {},
  resetAllFeatures: () => {},
};

const MainContext = React.createContext<MainContextType>(INITIAL_STATE);

export const useMainContext = () => React.useContext(MainContext);

export const MainProvider: React.FC<Partial<React.PropsWithChildren>> = ({
  children,
}) => {
  const [addressFeature, setAddressFeature] = React.useState<Feature | null>(
    null
  );
  const [votingFeatures, setVotingFeatures] = React.useState<Feature[] | null>(
    null
  );

  const resetAllFeatures = () => {
    setAddressFeature(null);
    setVotingFeatures(null);
  };

  React.useEffect(() => {
    // inisialise pymjs
    const pymChild = new pym.Child();
    pymChild.sendHeight();
  }, []);

  return (
    <MainContext.Provider
      value={{
        addressFeature,
        setAddressFeature,
        votingFeatures,
        setVotingFeatures,
        resetAllFeatures,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};
